import { render, staticRenderFns } from "./AddNewMessageAdmin.vue?vue&type=template&id=9f94bb94&scoped=true&"
import script from "./AddNewMessageAdmin.vue?vue&type=script&lang=js&"
export * from "./AddNewMessageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AddNewMessageAdmin.vue?vue&type=style&index=0&id=9f94bb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f94bb94",
  null
  
)

export default component.exports